import React, {Component} from 'react';
import {Input} from 'semantic-ui-react';

import './inputField.scss';

class InputField extends Component {
  render() {
    const {input, id, type, label, placeholder, required, icon, meta, loading,
      invalidMessage = 'Por favor, llene este campo', ...custom} = this.props;
    return (
      <div className='form-input-field'>
        <Input
          id={id}
          type={type}
          label={label}
          placeholder={placeholder}
          required={required}
          icon={icon}
          error={meta.touched && (typeof meta.error === 'string' ? true : meta.error)}
          {...input}
          {...custom}
          onInvalid={this.setError.bind(this, invalidMessage)}
          onInput={this.setError.bind(this, '')}
          loading={loading}
        />
        {meta.touched && (meta.error && <span className='error-message'>{meta.error}</span>)}
      </div>
    );
  }

  setError(message, event) {
    event.stopPropagation();
    event.target.setCustomValidity(message);
  }
}

export default InputField;
